import Style, {PolygonIMDFSettings} from "../../models/style";
import {Column, Row} from "../flex";
import {Checkbox, InputGroup} from "@blueprintjs/core";
import {useEffect, useState} from "react";
import {isNumericString} from "../../common";

interface Props {
  style: Style
}

export function PolygonTypeEditor({ style }: Props) {
  const [settings, setSettings] = useState(style.polygonTypesSettings);

  useEffect(() => {
    console.log('style changed imdf settings', style.polygonTypesSettings);
    setSettings(style.polygonTypesSettings);
  }, [style]);

  useEffect(() => {
    console.log('polygon types settings', settings);
    style.updatePolygonTypeSetting(settings)
  }, [settings, style]);

  return (
    <Column flex={1} className="edit-block">
      <Row flex={1}>
        <div style={{ flex: 1, fontWeight: 500 }}><strong>Polygon Type</strong></div>
        <div style={{ width: 50 }}><strong>IMDF</strong></div>
        <div style={{ width: 54 }}><strong>Shrink %</strong></div>
      </Row>

      {style.polygonTypes.map((polygonType, index) => {

        return (<Row key={index} flex={1} style={{ alignItems: 'center', justifyContent: 'center', marginBottom: 6 }}>
          <div style={{ flex: 1 }}>{polygonType}</div>
          <div className="bp3-reset" style={{ height: '100%', width: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Checkbox checked={settings[polygonType].imdf} onChange={(e) => {
              const _settings = Object.assign({}, settings);
              _settings[polygonType].imdf = e.currentTarget.checked;
              setSettings(_settings)
            }} />
          </div>
          <div><InputGroup style={{ width: 48, marginRight: 6 }} onChange={e => {
            const value = e.currentTarget.value;

            if (!isNumericString(value)) {
              alert("The shrink value must be a number between 0 and 100. Decimal values (99.5) are allowed.");
              return
            }

            const _settings = Object.assign({}, settings);
            _settings[polygonType].shrink = parseFloat(e.currentTarget.value);
            setSettings(_settings)
          }} /></div>
        </Row>)
      })}
    </Column>
  )
}
